module.exports = __webpack_public_path__ + "img/tablet-VTA-VALORACION-REAGENDADA.c0b00191.png";